import api from '@/utils/api';

export default {
    data: () => ({personAdditionResult: null, personRefreshNotice: '', reservePersonForAddition: null}),
    computed: {
        personAdditionIdentity() {
            const user = this.$store.getters.currentUser || {};
            return JSON.stringify([user.company, user.userId]);
        }
    },
    watch: {personAdditionIdentity() { this.resetPersonForm(); }},
    beforeDestroy() { this.resetPersonAddition(); },
    methods: {
        resetPersonAddition() {
            this._personAdditionSequence = (this._personAdditionSequence || 0) + 1;
            this.personAdditionResult = null;
            this.personRefreshNotice = '';
            this.reservePersonForAddition = null;
            this.addingPerson = false;
            this.addingEmployeeId = null;
        },
        isCurrentPersonAddition(operation) {
            const user = this.$store.getters.currentUser || {};
            return operation.sequence === this._personAdditionSequence && this.addPersonModalVisible
                && operation.company === user.company && operation.userId === user.userId
                && operation.timesheetId === this.currentTimesheetId();
        },
        addEmployee(person) {
            if (this.addingPerson || this.personAdditionResult) return;
            if (person.lifecycle_status === 'reserve') {
                this.reservePersonForAddition = person;
                this.addPersonError = '';
                this.$nextTick(() => { if (this.$refs.reservePersonDetails) this.$refs.reservePersonDetails.focus(); });
                return;
            }
            return this.submitPersonAddition('employee', person.full_name, {
                employee_id: person.employee_id, reason: this.addReason
            });
        },
        backToPersonSearch() {
            if (this.addingPerson) return;
            this.reservePersonForAddition = null;
            this.addPersonError = '';
            this.$nextTick(() => { if (this.$refs.personSearchInput) this.$refs.personSearchInput.focus(); });
        },
        confirmReservePersonAddition() {
            const person = this.reservePersonForAddition;
            if (!person) return;
            return this.submitPersonAddition('employee', person.full_name, {
                employee_id: person.employee_id, reason: this.addReason
            });
        },
        addUnresolved(confirmNoMatch) {
            const name = this.unresolvedForm.full_name || this.peopleQuery;
            return this.submitPersonAddition('unresolved', name, {
                full_name: name, phone: this.unresolvedForm.phone || null,
                reason: this.addReason, confirm_no_match: confirmNoMatch === true
            });
        },
        async submitPersonAddition(kind, name, payload) {
            if (this.addingPerson || this.personAdditionResult || !this.currentTimesheetId()) return;
            const user = this.$store.getters.currentUser || {};
            const operation = {
                sequence: this._personAdditionSequence = (this._personAdditionSequence || 0) + 1,
                company: user.company, userId: user.userId, timesheetId: this.currentTimesheetId(),
                name, message: kind === 'unresolved'
                    ? `${name} добавлен как человек без карточки.` : `${name} добавлен в табель.`
            };
            this.addPersonError = '';
            this.personRefreshNotice = '';
            this.matchCandidates = null;
            this.addingPerson = true;
            this.addingEmployeeId = kind === 'employee' ? Number(payload.employee_id) : null;
            try {
                try {
                    await api.post(`/api/timesheets/${operation.timesheetId}/lines/${kind}`, payload, {ignoreModal: true});
                } catch (error) {
                    if (!this.isCurrentPersonAddition(operation)) return;
                    const data = error && error.response && error.response.data;
                    if (kind === 'unresolved' && data && data.code === 'TIMESHEET_PERSON_MATCH_CONFIRMATION_REQUIRED') {
                        this.matchCandidates = data.details;
                    } else if (kind === 'unresolved' && data && data.code === 'TIMESHEET_UNRESOLVED_ALREADY_IN_TIMESHEET') {
                        // The server confirmed an existing row. Reload it; never submit another addition.
                        operation.existingLineId = Number(data.details && data.details.line_id);
                        operation.message = `${name} уже есть в этом табеле.`;
                        this.personAdditionResult = operation;
                        await this.refreshPersonAddition(operation);
                    } else {
                        this.addPersonError = this.responseMessage(error, kind === 'unresolved'
                            ? 'Не удалось добавить человека.' : 'Не удалось добавить сотрудника.');
                    }
                    return;
                }
                if (!this.isCurrentPersonAddition(operation)) return;
                // A successful POST is final even if the following GET or screen update fails.
                this.personAdditionResult = operation;
                await this.refreshPersonAddition(operation);
            } finally {
                if (this.isCurrentPersonAddition(operation)) {
                    this.addingPerson = false;
                    this.addingEmployeeId = null;
                }
            }
        },
        async retryPersonAdditionRefresh() {
            const operation = this.personAdditionResult;
            if (this.addingPerson || !operation || !this.isCurrentPersonAddition(operation)) return;
            this.addingPerson = true;
            try { await this.refreshPersonAddition(operation); }
            finally { if (this.isCurrentPersonAddition(operation)) this.addingPerson = false; }
        },
        async refreshPersonAddition(operation) {
            this.personRefreshNotice = '';
            try {
                const refreshed = await this.loadTimesheet(operation.timesheetId, {
                    syncRoute: false, ignoreModal: true, throwActivityErrors: true,
                    isCurrent: () => this.isCurrentPersonAddition(operation)
                });
                if (!this.isCurrentPersonAddition(operation)) return;
                if (refreshed === false) {
                    this.personRefreshNotice = 'Обновление табеля отложено. Дождитесь сохранения текущих правок и нажмите «Обновить табель». Повторно добавлять сотрудника не нужно.';
                    return;
                }
                const existingLine = operation.existingLineId
                    ? this.unresolvedLines.find(line => Number(line.id) === operation.existingLineId) : null;
                if (operation.existingLineId && !existingLine) {
                    this.personRefreshNotice = 'Не удалось найти существующую строку в обновлённом табеле. Повторите обновление; добавлять сотрудника заново не нужно.';
                    return;
                }
                this.successMessage = operation.message;
                this.resetPersonForm();
                if (existingLine) {
                    const sequence = this._personAdditionSequence;
                    this.$nextTick(() => {
                        const user = this.$store.getters.currentUser || {};
                        if (sequence === this._personAdditionSequence && operation.timesheetId === this.currentTimesheetId()
                            && operation.company === user.company && operation.userId === user.userId) this.openUnresolvedResolver(existingLine);
                    });
                }
            } catch (error) {
                if (!this.isCurrentPersonAddition(operation)) return;
                const status = error && error.response && error.response.status;
                if (status === 401 || status === 403) {
                    this.clearCurrentTimesheet();
                    this.errorMessage = `${operation.message} Просмотр табеля сейчас недоступен: проверьте вход и права доступа.`;
                    return;
                }
                this.personRefreshNotice = 'Не удалось обновить табель. Повторно добавлять сотрудника не нужно. Нажмите «Обновить табель».';
            }
        }
    }
};
